import { useState, useEffect, useCallback } from "react";

const DEFAULT_MIN_ROWS = 30;
const ROW_HEIGHT_EST_PX = 49;
/** Space for app header, contacts title, toolbar, pagination strip */
const VIEWPORT_OFFSET_PX = 200;

/**
 * Rows per page from viewport height, at least `minRows`.
 * Recalculates on window resize (debounced).
 */
export function useDynamicRowsPerPage(minRows = DEFAULT_MIN_ROWS) {
  const [rowsPerPage, setRowsPerPage] = useState(minRows);

  const recalc = useCallback(() => {
    if (typeof window === "undefined") return;
    const h = window.innerHeight;
    const available = Math.max(0, h - VIEWPORT_OFFSET_PX);
    const fit = Math.floor(available / ROW_HEIGHT_EST_PX);
    setRowsPerPage(Math.max(minRows, fit > 0 ? fit : minRows));
  }, [minRows]);

  useEffect(() => {
    recalc();
    let timeoutId;
    const onResize = () => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(recalc, 200);
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.clearTimeout(timeoutId);
    };
  }, [recalc]);

  return rowsPerPage;
}
